// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u32().primaryKey(),
  users: __t.u32(),
  usersOnline: __t.u32().name("users_online"),
  orgs: __t.u32(),
  projects: __t.u32(),
  clips: __t.u32(),
  assets: __t.u32(),
  storageUsedBytes: __t.f64().name("storage_used_bytes"),
  jobsQueued: __t.u32().name("jobs_queued"),
  jobsRunning: __t.u32().name("jobs_running"),
  jobsFailed: __t.u32().name("jobs_failed"),
  workersOnline: __t.u32().name("workers_online"),
  connections: __t.u32(),
  pendingEmails: __t.u32().name("pending_emails"),
  pendingGc: __t.u32().name("pending_gc"),
});
